module.exports = __webpack_public_path__ + "img/warning-sign.74118547.svg";